/**
 * This file is auto-generated. Any modifications will be
 * overwritten by the generate-icon npm script.
 */
import React from 'react';
import { SvgIcon } from "../shared/SvgIcon";
var ArrowUpOutlineIcon = function ArrowUpOutlineIcon(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, props, /*#__PURE__*/React.createElement("path", {
    d: "M10.9999 7.72579L7.02078 11.3923L5.66553 9.92151L12 4.08472L18.3345 9.92151L16.9792 11.3923L12.9999 7.72568V20.0001H10.9999V7.72579Z"
  }));
};
export default ArrowUpOutlineIcon;